// extracted by mini-css-extract-plugin
module.exports = {"pagination":"ProspectsList_pagination__22pgR","wrapper":"ProspectsList_wrapper__38Cio"};